import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class ContractTransactions extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default ContractTransactions
